import api from '../services/api';
import Cookies from 'js-cookie';

export default async function getResource() {
  
  let _token = Cookies.get('user-token');
  _token = _token ? JSON.parse(_token) : null;
  const config = {
    headers: { Authorization: `Bearer ${_token?.token}` }
  };
  
  const _resources_raw = await api.get('resources?paginate=false', config);
  const _providers_raw = await api.get('providers?paginate=false', config);

  let _resources = _resources_raw.data;
  let _providers = _providers_raw.data;
  let _categories = []
  _resources_raw.data.forEach(e => {
    if(e.category.only_attendance === 0) {
      if(!_categories.find(e2 => e2.id === e.category.id)) {
        _categories.push({
          id: e.category.id,
          name: e.category.name,
          only_attendance: e.category.only_attendance,
          main_events: e.category.main_events,
          resources: []
        })
      }
      _categories.find(e2 => e2.id === e.category.id).resources.push({
        id: e.id,
        in_config: e.in_config,
        name: e.name,
        only_attendance: e.only_attendance,
        avaible_supliers: e.provider
      })
    }
  })

  _categories = _categories.map(__category => {
    let _resources = __category.resources;
    _resources.sort((a, b) => {
      return a.name.toUpperCase() > b.name.toUpperCase()
    })
    return {
      ...__category,
      resources: _resources
    }
  })
  _categories.sort((a, b) => {
    return a.name.toUpperCase() > b.name.toUpperCase()
  })

  _resources = _resources.map(__resource => {
    let _provider = __resource.provider;
    _provider.sort((a, b) => {
      return a.name.toUpperCase() > b.name.toUpperCase()
    })
    return {
      ...__resource,
      provider: _provider
    }
  })
  _resources.sort((a, b) => {
    return a.name.toUpperCase() > b.name.toUpperCase()
  })
  
  _providers = _providers.map(__provider => {
    let _resources = __provider.resources;
    _resources.sort((a, b) => {
      return a.name.toUpperCase() > b.name.toUpperCase()
    })
    return {
      ...__provider,
      resources: _resources
    }
  })
  _providers.sort((a, b) => {
    return a.name.toUpperCase() > b.name.toUpperCase()
  })

  return {
    resources: _resources_raw.data.filter(e => e.only_attendance === 0).map(e => ({
      id: e.id,
      name: e.name,
      in_config: e.in_config,
      only_attendance: e.only_attendance,
      avaible_supliers: e.provider,
      category: e.category
    })),
    categories: _categories,
    supliers: _providers_raw.data
  };
}